import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { IBaseResponse } from "../interface/IBaseResponse";
import { IRollbackReconcileSettlement } from "../interface/settlements/IRollbackReconcileSettlement";
import { IRollbackReconcileSettlementRequest } from "../interface/settlements/IRollbackReconcileSettlementRequest";

enum RollbackReconcileSettlementServiceEnum {
  base = "/"
}

export default class RollbackReconcileSettlementService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/rollback-reconcile-settlement");
  }

  public getAll = async (): Promise<IRollbackReconcileSettlement[]> => await this.GET(RollbackReconcileSettlementServiceEnum.base);

  public create = async (data: IRollbackReconcileSettlementRequest): Promise<IBaseResponse> => await this.POST(RollbackReconcileSettlementServiceEnum.base, data);
}
